/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PopiaStatusViewModel } from './PopiaStatusViewModel';
import {
    PopiaStatusViewModelFromJSON,
    PopiaStatusViewModelFromJSONTyped,
    PopiaStatusViewModelToJSON,
} from './PopiaStatusViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfPopiaStatusViewModel
 */
export interface ResultOfPopiaStatusViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfPopiaStatusViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfPopiaStatusViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfPopiaStatusViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfPopiaStatusViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfPopiaStatusViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfPopiaStatusViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfPopiaStatusViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {PopiaStatusViewModel}
     * @memberof ResultOfPopiaStatusViewModel
     */
    data?: PopiaStatusViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfPopiaStatusViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfPopiaStatusViewModel interface.
 */
export function instanceOfResultOfPopiaStatusViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfPopiaStatusViewModelFromJSON(json: any): ResultOfPopiaStatusViewModel {
    return ResultOfPopiaStatusViewModelFromJSONTyped(json, false);
}

export function ResultOfPopiaStatusViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfPopiaStatusViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : PopiaStatusViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfPopiaStatusViewModelToJSON(value?: ResultOfPopiaStatusViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': PopiaStatusViewModelToJSON(value.data),
        'Count': value.count,
    };
}

